export enum StatsElementSimpleGridMonthColumnValue {
  Total = 'Total',
}
